export default __webpack_public_path__ + "static/small-text-dont-d4eed76c6f45151fa25d558f6049184f.png";